var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1083.024 -1019.412)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1083.774 1024.574)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.625,0H3.219A3.121,3.121,0,0,0,0,3.384v5.35a3.118,3.118,0,0,0,3.219,3.384H8.9a3.119,3.119,0,0,0,3.22-3.384V6.142",
    transform: "translate(0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "{1.5} "
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0,10.919V0",
    transform: "translate(1089.832 1030.633) rotate(-135)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "{1.5} "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.278,0,3.139,3.153,0,0",
    transform: "translate(1097.544 1027.361) rotate(-135)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "{1.5} "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external_link.70dba734db4161df48baa142c4301512.svg";
export { ForwardRef as ReactComponent };